import Colors from 'constants/Colors';

export default {
  buttonStyle: {
    width: '50%',
    marginTop: 32,
  },
  deleteButton: {
    width: '50%',
    marginTop: 32,
    backgroundColor: Colors.red,
    border: `1px solid ${Colors.red}`,
  },
  input: {
    color: Colors.darkText,
    width: '100%',
    border: `1px solid ${Colors.layoutContainerBg}`,
  },
  button: {
    backgroundColor: Colors.layoutContainerBg,
    border: `1px solid ${Colors.layoutContainerBg}`,
  },
  inputTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: Colors.darkText,
  },
  titleModal: {
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '8px',
  },
  textModal: {
    fontSize: '13px',
    color: '#333',
    textAlign: 'center',
    marginBottom: '20px',
  },
  modalButton: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center',
  },
  textContainerModal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
   iconModal: {
    margin: '25px 0px',
    backgroundColor: Colors.redDesactivedBg,
    color: Colors.red,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
